import { PageRoutes } from 'common/constants';
import { appendBasePath } from 'common/navUtils';
import DataCollection from 'pages/dataCollection/DataCollection';
import DocusignReturn from 'pages/docusignReturn/DocusignReturn';
import NotFound from 'pages/notFound/NotFound';
import TransferFlow from 'pages/transfer/TransferFlow';
import React, { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';
import ErrorBoundary from './ErrorBoundary';
import Errorpage from './Errorpage/Errorpage';
import Footer from './Footer';
import Header from './Header';
import SessionExpiration from './SessionExpiration';

/**
 * The root of the App itself. Everything here and below assumes that AuthServiceProvider
 * has been utilized above it, so all auth components and hooks are available.
 *
 * @constructor
 */
const App: FC = () => {
  return (
    <div id="app" className="flex flex-col h-full overflow-auto">
      <BrowserRouter basename={appendBasePath('/')}>
        <ErrorBoundary>
          <Header />
          <Routes>
            <Route path={PageRoutes.HOME} element={<TransferFlow />} />
            <Route path={PageRoutes.DATACOLLECTION} element={<DataCollection />} />
            <Route path={PageRoutes.CONFIRMATION} element={<DocusignReturn />} />
            <Route path={PageRoutes.ERROR} element={<Errorpage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <div className="asset-transfer-lrn-container">
            <div className="asset-transfer-lrn">4584696</div>
          </div>
          <Footer />
          <SessionExpiration />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
};

export default App;
